// Components
import TableRowMobil from '../TableRowShoppingCartMobil';

// Styles
import styles from './index.module.sass';
import Skeleton from '@mui/material/Skeleton';

type Props = {
  order: Object,
  getOrder: Function,
  device: Object,
};

export default function OrderTable({ order = {}, getOrder, device, loading }: Props): React$Node {
  const orderDetail = order?.detallePedido || [];

  const screenSize = device?.screenSize || 'desktop';

  return (
    <div className={`${styles.container} ${styles[screenSize]}`}>
      <div className={styles.header}>Productos</div>
      <div className={styles.tableData}>
        {(loading && (
          <div>
            <Skeleton
              variant='rectangular'
              className={styles.loadingText}
              sx={{ bgcolor: 'grey.200' }}
            />

            <Skeleton
              variant='rectangular'
              className={styles.loadingText}
              sx={{ bgcolor: 'grey.200' }}
            />

            <Skeleton
              variant='rectangular'
              className={styles.loadingText}
              sx={{ bgcolor: 'grey.200' }}
            />
          </div>
        )) ||
          orderDetail.map((val, key) => {
            return <TableRowMobil node={val} key={key} getOrder={getOrder} device={device} />;
          })}
      </div>
    </div>
  );
}
